/**************************************************
 * Nombre:       Dialogo_Comision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Comision from "../Formularios/Formulario_Comision";
import {obtenerComisionConsultor} from "../../CodigoNegocio/Comisiones/obtenerComisionConsultor";
import {adap_comision_usuario} from "../../CodigoNegocio/Apatadores/adap_comision_usuario";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import {obtenerComisionDistribuidor} from "../../CodigoNegocio/Comisiones/obtenerComisionDistribuidor";

const Dialogo_Comision = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        //  console.log(entidad)

        iniciarCarga('Subiendo Datos')
        entidad.fecha = new Date().getTime()

        let comisiones = {}

        if (entidad.distribuidor) {
            comisiones = obtenerComisionDistribuidor(entidad, cData.usuario)
        } else {
            comisiones = obtenerComisionConsultor(entidad, cData.usuario)
        }


        let data = adap_comision_usuario(comisiones, cData.usuario, entidad)

        // console.log(data)

        let dox = await guardarDoc('simulaciones', data)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('simulaciones', datos.id)
        terminar({aviso: 'Simulacion borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Comision props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Crear Simulacion</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Comision